import React from "react";
import Isvg from "../../../vendor/react-inlinesvg";

const EditContainer = ({
  className,
  cancelEditCallback,
  children,
  dataUID,
  leftHeader,
  rightHeader,
  saveEditCallback,
  style,
  title
}) => (
  <div
    key="edit-container"
    data-uid={dataUID}
    className={`edit-container ${className}`}
    style={style}
  >
    <div className="header">
      <div className="edit-title">{title}</div>
      {cancelEditCallback && (
        <button
          className="edit-button cancel-edit noButton"
          onClick={cancelEditCallback}
        >
          {leftHeader || <Isvg src="/img/x_medium_icon.svg">NS</Isvg>}
        </button>
      )}
      {saveEditCallback && (
        <button
          className="edit-button save-edit noButton"
          onClick={saveEditCallback}
        >
          {rightHeader || i18n.t("base.save")}
        </button>
      )}
    </div>
    <div className="content">{children}</div>
  </div>
);

export default EditContainer;
